import React from 'react';

import { flagStyles } from '../settings';

const SvgAI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-96px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAI;
